var exports = {
  "kL": "xfd349460--fbfb47--container" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "Cv": "xfd349460--fbfb47--about",
  "DD": "xfd349460--fbfb47--title",
  "h_": "xfd349460--fbfb47--description",
  "ne": "xfd349460--fbfb47--controls",
};

module.exports = exports;
